/**
 * @file Defines API resources names
 */
const RESOURCES = {
    '3dsecure': '3dsecure',
    activityFeed: 'activity-feed',
    apiKeys: 'api-keys',
    apiTracking: 'api-tracking',
    attachments: 'attachments',
    authenticationOptions: 'authentication-options',
    authenticationTokens: 'authentication-tokens',
    awsSesCredentials: 'aws-ses-credentials',
    bankAccounts: 'bank-accounts',
    blacklists: 'blacklists',
    checkoutPages: 'checkout-pages',
    contacts: 'contacts',
    coupons: 'coupons',
    couponsRedemptions: 'coupons-redemptions',
    credentials: 'credentials',
    creditMemos: 'credit-memos',
    customFields: 'custom-fields',
    customerTimeline: 'customer-timeline',
    customers: 'customers',
    dataExports: 'data-exports',
    disputes: 'disputes',
    emailMessages: 'email-messages',
    emailNotifications: 'email-notifications',
    // emailNotificationsTracking: 'email-notifications-tracking',
    events: 'events',
    files: 'files',
    gatewayAccountDowntimes: 'gateway-account-downtimes',
    gatewayAccountTimeline: 'gateway-account-timeline',
    gatewayAccounts: 'gateway-accounts',
    gridSegments: 'grid-segments',
    histograms: 'histograms',
    integrations: 'integrations',
    invoices: 'invoices',
    kyc: 'kyc',
    layouts: 'layouts',
    leadSources: 'lead-sources',
    lists: 'lists',
    listsTracking: 'lists-tracking',
    mailgunCredentials: 'mailgun-credentials',
    matchedRules: 'matched-rules',
    // mgs: 'mgs',
    // momentum: 'momentum',
    // nmi: 'nmi',
    notes: 'notes',
    oauth2Credentials: 'oauth2-credentials',
    organizations: 'organizations',
    passwordTokens: 'password-tokens',
    paymentCards: 'payment-cards',
    paymentCardsMigrations: 'payment-cards-migrations',
    paymentInstrumentValidation: 'payment-instrument-validation',
    payments: 'payments',
    paypalAccounts: 'paypal-accounts',
    plans: 'plans',
    postmarkCredentials: 'postmark-credentials',
    products: 'products',
    // profile: 'profile',
    reports: 'reports',
    resetSandbox: 'reset-sandbox',
    rulesets: 'rulesets',
    // search: 'search',
    sendPreviewEmail: 'send-preview-email',
    sendPreviewWebhook: 'send-preview-webhook',
    sendgridCredentials: 'sendgrid-credentials',
    shippingZones: 'shipping-zones',
    smtpCredentials: 'smtp-credentials',
    subscriptionTracking: 'subscription-tracking',
    subscriptions: 'subscriptions',
    tags: 'tags',
    tokens: 'tokens',
    transactionTimeline: 'transaction-timeline',
    transactions: 'transactions',
    users: 'users',
    webhookCredentials: 'webhook-credentials',
    webhooks: 'webhooks',
    webhooksTracking: 'webhooks-tracking',
    websites: 'websites',
    websitesWebhook: 'websites-webhook',
};

export default RESOURCES;

export const RESOURCE_LIST = Object.values(RESOURCES);
